import { decodeHtmlEntities } from "../utils";
import { ComputeFieldComponent } from "../computeFields";
import { Collector } from "../types";

/**
 * Localisation « Ville - Pays » du collectionneur, en respectant la publication
 * par champ (Ville et Pays sont masquables indépendamment). Iso front.
 */
function formatCollectorLocation(input: {
  collectionneursDescriptionVille?: string;
  collectionneursDescriptionVillePublished?: boolean;
  collectionneursDescriptionPays?: string;
  collectionneursDescriptionPaysPublished?: boolean;
}): string {
  const parts: string[] = [];
  const ville = decodeHtmlEntities(
    input.collectionneursDescriptionVille ?? "",
  ).trim();
  const pays = decodeHtmlEntities(
    input.collectionneursDescriptionPays ?? "",
  ).trim();
  if (input.collectionneursDescriptionVillePublished !== false && ville) {
    parts.push(ville);
  }
  if (input.collectionneursDescriptionPaysPublished !== false && pays) {
    parts.push(pays);
  }
  return parts.join(" - ");
}

type CollectorLocationInput = Partial<
  Pick<
    Collector,
    | "collectionneursDescriptionVille"
    | "collectionneursDescriptionVillePublished"
    | "collectionneursDescriptionPays"
    | "collectionneursDescriptionPaysPublished"
  >
> & {
  showCity?: boolean;
};

export const CollectorNameCF: ComputeFieldComponent<
  Pick<
    Collector,
    | "collectionneursDescriptionNom"
    | "collectionneursDescriptionPrenom"
    | "collectionneursDescriptionCollectionPublique"
  > &
    CollectorLocationInput
> = ({ input }) => {
  const nom = decodeHtmlEntities(input.collectionneursDescriptionNom ?? "");
  const prenom = decodeHtmlEntities(
    input.collectionneursDescriptionPrenom ?? "",
  );

  const base = input.collectionneursDescriptionCollectionPublique ? (
    <>{nom} </>
  ) : (
    <>
      {prenom && <>{prenom} </>}
      {nom && <>{nom} </>}
    </>
  );

  const location = formatCollectorLocation(input);

  return (
    <>
      {base}
      {location && (input.showCity ?? false) && <>({location})</>}
    </>
  );
};

export const CollectorNameForOverviewCF: ComputeFieldComponent<
  Pick<
    Collector,
    | "collectionneursDescriptionNom"
    | "collectionneursDescriptionPrenom"
    | "collectionneursDescriptionCollectionPublique"
  > &
    CollectorLocationInput
> = ({ input, ...props }) => {
  const nom = decodeHtmlEntities(input.collectionneursDescriptionNom ?? "");
  const prenom = decodeHtmlEntities(
    input.collectionneursDescriptionPrenom ?? "",
  );

  const base = input.collectionneursDescriptionCollectionPublique ? (
    <>
      {prenom && <>{prenom} </>}
      {nom && <>{nom} </>}
    </>
  ) : (
    <>{props.translation?.("computeField.collectionParticuliere") ?? ""} </>
  );

  const location = formatCollectorLocation(input);

  return (
    <>
      {base}
      {location && (input.showCity ?? false) && <>({location})</>}
    </>
  );
};
